export default "/public/app-main/static/image/c9f64a22108e17fc0afa53dce3c9bd1f.png";